export default __webpack_public_path__ + "static/img1-5ef6c3ce07dfb1c6230cafa5d2b87419.png";